<template>
  <div class="dialog mask" v-if="show">
    <div class="box">
      <div class="header">
        <div class="title">{{title}}</div>
        <div class="close" @click="show = false">X</div>
      </div>
      <div class="main">
        <selectClass :curClassObj="curClassObj" v-if="curType === 'selectClass' && Object.keys(curClassObj).length > 0" />
        <sVideo v-if="curType === 'sVideo'" :videoSrc="curSVideoObj.url" :curClass="curSVideoObj.class" :mainConfig="mainConfig" :loginStatus="loginStatus" />
        <gift v-if="curType === 'gift' && curGiftList.length > 0" :curGiftList="curGiftList" />
      </div>
    </div>
  </div>
</template>

<script>
import selectClass from "./cell/selectClass"
import sVideo from "./cell/sVideo"
import gift from "./cell/gift"
export default {
  name: "Dialog",
  components: {
    selectClass,
    sVideo,
    gift
  },
  props: {
    title: {
      type:String,
      default: ""
    },
    curType: {
      type: String,
      default: ""
    },
    curClassObj: {
      type: Object,
      default: () => {}
    },
    curSVideoObj: {
      type: Object,
      default: () => {}
    },
    curGiftList: {
      type: Array,
      default: () => []
    },
    mainConfig: {
      type: Object,
      default: () => {}
    },
    loginStatus: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog{
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  user-select: none;
  z-index: 1002;
  background: rgba(0, 0, 0, .7);
  .box{
    position: relative;
    top: calc(50% - 270px);
    left: calc(50% - 420px);
    width: 840px;
    height: 560px;
    z-index: 1001;
    border-radius: 20px;
    background: white;
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E5E5E5;
      .title{
        min-height: 16px;
        padding: 15px 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: bold;
        cursor: default;
        color: #333;
      }
      .close{
        cursor: pointer;
        background: transparent;
        font-weight: bold;
        color: #000;
        text-shadow: 0 1px 0 #FFF;
        opacity: .2;
        font-size: 18px;
        padding-right: 16px;
      }
    }
    .main{
      padding: 10px 20px 20px;
    }
  }
}
</style>